import { allCalculators, calculatorCategories } from '@/lib/calculator-data';
import { Link } from 'react-router-dom';
import { useSEO } from '@/hooks/useSEO';

export default function SitemapPage() {
  useSEO(
    'Sitemap | Earning Calculators.Com',
    'A list of all pages and calculators available on Earning Calculators.Com.'
  );

  const calculatorsByCat = allCalculators.reduce((acc, calc) => {
    if (!acc[calc.category]) {
      acc[calc.category] = [];
    }
    acc[calc.category].push(calc);
    return acc;
  }, {} as Record<string, typeof allCalculators>);

  const otherPages = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms of Service', path: '/terms' },
    { name: 'Disclaimer', path: '/disclaimer' },
  ];

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-headline text-4xl md:text-5xl font-bold tracking-tighter mb-12 text-center">
          Sitemap
        </h1>
        
        <div className="space-y-12">
          <section>
            <h2 className="font-headline text-3xl font-semibold tracking-tight mb-6 border-b pb-3">
              Main Pages
            </h2>
            <ul className="space-y-2 list-disc pl-5">
              {otherPages.map(page => (
                <li key={page.path}>
                  <Link to={page.path} className="text-primary hover:underline text-lg">
                    {page.name}
                  </Link>
                </li>
              ))}
            </ul>
          </section>

          {calculatorCategories.map(category => (
            <section key={category.id}>
              <h2 className="font-headline text-3xl font-semibold tracking-tight mb-6 border-b pb-3">
                {category.name}
              </h2>
              <ul className="space-y-2 list-disc pl-5">
                {calculatorsByCat[category.id]?.map(tool => (
                  <li key={tool.slug}>
                    <Link to={`/calculators/${tool.slug}`} className="text-primary hover:underline text-lg">
                      {tool.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}